import React, { useState } from 'react';
import { ChevronDownIcon, GiftIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const bonuses = [{
    title: 'BONO 1 — PACK DE PLANTILLAS EDITABLES',
    preview: 'https://cdn.magicpatterns.com/uploads/jpT9b9r4S6p4r89eGHy2Zu/Screenshot_2026-06-20_at_6.26.43_PM.png',
    items: ['✅ Legajo de empleado', '✅ Formulario de ingreso', '✅ Acta de apercibimiento', '✅ Carta documento de despido', '✅ Notificación de vacaciones', '✅ Entrevista de permanencia', '✅ Entrevista de salida', '✅ Reporte mensual de RRHH', '✅ Planilla de asistencia automática', '✅ Base maestra de empleados']
  }, {
    title: 'BONO 2 — GUÍA DE SITUACIONES DE ALTO RIESGO LEGAL',
    subtitle: '15 Casos Reales de PYMES Argentinas',
    preview: 'https://cdn.magicpatterns.com/uploads/uSVmSDkPi3WWEA1EocNjuD/Screenshot_2026-06-20_at_6.27.10_PM.png',
    items: ['• Trabajo no registrado', '• Despido sin documentación', '• Embarazo', '• Monotributo encubierto', '• Accidentes laborales', '• Mobbing', '• Hostigamiento', '• Abandono de trabajo', '• Licencias mal gestionadas', '• Certificados médicos cuestionados', '• Horas extras reclamadas', '• Falta de sanciones documentadas', '• Conflictos sindicales básicos', '• Desvinculaciones conflictivas', '• Errores de legajo']
  }, {
    title: 'BONO 3 — CALENDARIO ANUAL DE RRHH',
    subtitle: 'Sistema de Organización Anual',
    preview: 'https://cdn.magicpatterns.com/uploads/qBjqER61iuj5xYe74QP5bR/Screenshot_2026-06-20_at_6.27.19_PM.png',
    items: ['✅ SAC', '✅ Vacaciones', '✅ Evaluaciones de desempeño', '✅ Períodos de prueba', '✅ ART', '✅ Capacitaciones', '✅ Entrevistas de seguimiento', '✅ Reportes mensuales', '✅ Alertas automáticas', '✅ Vista anual y mensual editable']
  }, {
    title: 'BONO 4 — CALCULADORA DE INDEMNIZACIÓN Y LIQUIDACIÓN FINAL',
    subtitle: 'Planilla automática lista para usar',
    preview: 'https://cdn.magicpatterns.com/uploads/7dqwdzUc3JVmNuGMVmq7QX/Screenshot_2026-06-24_at_1.25.46_PM.png',
    items: ['✅ Liquidación final completa', '✅ Indemnización por antigüedad (art. 245 LCT)', '✅ Preaviso e integración del mes', '✅ SAC y vacaciones proporcionales', '✅ Cálculo automático paso a paso', '✅ Guía y referencias incluidas']
  }, {
    title: 'BONO 5 — CALCULADORA DE LIQUIDACIONES DE SUELDOS',
    subtitle: 'Planilla automática lista para usar',
    preview: 'https://cdn.magicpatterns.com/uploads/9DVpMYZWghvzZjBwCCFCoy/Screenshot_2026-06-24_at_1.25.05_PM.png',
    items: ['✅ Recibo de sueldo mensual', '✅ Haberes remunerativos y no remunerativos', '✅ Horas extra al 50% y 100%', '✅ Antigüedad y presentismo', '✅ Descuentos y aportes', '✅ Histórico anual y nómina del mes']
  }, {
    title: 'BONO 6 — GUION DE CONVERSACIONES DIFÍCILES',
    subtitle: 'Qué decir, palabra por palabra',
    preview: 'https://cdn.magicpatterns.com/uploads/5BnqvNx6t9oRoLhJjcHHc3/Screenshot_2026-06-24_at_1.26.37_PM.png',
    items: ['✅ Cómo dar una mala noticia', '✅ Qué decir si la persona se enoja', '✅ Cómo poner límites con calma', '✅ Frases listas para usar', '✅ Qué evitar en cada situación', '✅ Guion para entrevistas de salida']
  }];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-1">
      <div className="text-center mb-10" data-id="element-2">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-100 to-purple-100 px-6 py-3 rounded-full mb-4" data-id="element-3">
          <GiftIcon className="w-5 h-5 text-pink-600" data-id="element-4" />
          <span className="font-bold text-pink-600" data-id="element-5">GRATIS solo por hoy</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-6">
          6 Bonos Exclusivos
        </h2>
      </div>

      <div className="space-y-3" data-id="element-7">
        {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg border-2 border-purple-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-8">
            <div className="relative h-36 w-full overflow-hidden border-b border-purple-200 bg-white" data-id="element-9">
              <img src={bonus.preview} alt={`Vista previa de ${bonus.title}`} className="w-full h-full object-cover object-top" data-id="element-10" />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-50 via-purple-50/20 to-transparent" data-id="element-11" />
            </div>
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-white/50 transition-colors duration-200" data-id="element-12">
              <div data-id="element-13">
                <div className="flex items-center gap-2 mb-1" data-id="element-14">
                  <GiftIcon className="w-5 h-5 text-pink-500" data-id="element-15" />
                  <span className="text-xs font-semibold text-pink-600 uppercase" data-id="element-16">
                    Bono Gratis
                  </span>
                </div>
                <span className="font-semibold text-gray-900" data-id="element-17">
                  {bonus.title}
                </span>
                {bonus.subtitle && <p className="text-sm text-gray-600 mt-1" data-id="element-18">{bonus.subtitle}</p>}
              </div>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-19">
                <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-20" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-21">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-22">
                  <div className="px-6 py-4 bg-white/70 border-t border-purple-200" data-id="element-23">
                    <div className="grid md:grid-cols-2 gap-2" data-id="element-24">
                      {bonus.items.map((item, itemIndex) => <div key={itemIndex} className="text-gray-700 text-sm" data-id="element-25">
                          {item}
                        </div>)}
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}